import OQRScannerButton from './o-qr-scanner-button.vue';

export default OQRScannerButton;